<!--
  *** 开发人员: 本页面:王臣; 其他页面暂时性维护.
  *** 开发时间: 2024-07-05
  *** 功能描述: 全链预警-全部
  *** 版本号: v1.0.0
  *** 版权所有: 上海大智慧信息科技有限公司，并保留所有权利。
 -->
<template>
  <div class="All" :class="themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <ul class="th-ul">
      <li>指标名称</li>
      <li>当期值</li>
      <li>当期涨幅</li>
      <li>申万I级别</li>
      <li>频度</li>
    </ul>

    <div class="td-ul">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <ul>
          <li
            v-for="item in list"
            :key="item.codeId"
            @click="handleClickDetails(item)"
          >
            <span class="van-multi-ellipsis--l2">
              {{ item.factorName }}({{ item.unit }})
            </span>
            <span>{{ Number(item.factorValue?.vs) | formatAmount }}</span>
            <span
              v-if="item.updateFreqStr == '日'"
              :class="[judgeColor(item.factorValue?.p1zf)]"
            >
              {{ toFixedNum(item.factorValue?.p1zf, 2, "%") }}
            </span>

            <span
              v-else-if="item.updateFreqStr == '周'"
              :class="[judgeColor(item.factorValue?.d7zf)]"
            >
              {{ toFixedNum(item.factorValue?.d7zf, 2, "%") }}
            </span>

            <span
              v-else-if="item.updateFreqStr == '月'"
              :class="[judgeColor(item.factorValue?.d30zf)]"
            >
              {{ toFixedNum(item.factorValue?.d30zf, 2, "%") }}
            </span>

            <span v-else>-</span>

            <span>{{ item.indusName }}</span>
            <span>{{ item.updateFreqStr }}</span>
          </li>
        </ul>
      </van-list>
    </div>
  </div>
</template>

<script>
  export default {
    name: "All",
    data() {
      return {
        themeStyleVs: 1,
        list: [],
        pageNum: 1,
        loading: false,
        finished: false,
      };
    },
    components: {},
    watch: {},
    computed: {},
    filters: {
      /**
       * 将金额转换为带单位的字符串
       * @param {number} amount - 需要转换的金额
       * @param {number} [decimal=2] - 小数位数，默认保留2位小数
       * @returns {string} - 带单位的金额字符串，如果输入不合法，返回'--'
       */
      formatAmount(amount, decimal = 2) {
        if (isNaN(amount)) {
          return "-";
        }

        const units = ["", "万", "亿", "万亿"];
        let unitIndex = 0;
        let formattedAmount = amount;

        while (formattedAmount >= 10000 && unitIndex < units.length - 1) {
          formattedAmount /= 10000;
          unitIndex++;
        }

        return formattedAmount.toFixed(decimal) + units[unitIndex];
      },
    },
    created() {},
    async mounted() {
      this.themeStyleVs = this.$route.query.themeStyleVs || 1;
    },

    beforeDestroy() {},
    methods: {
      onLoad() {
        let _this = this;
        _this
          .$http({
            method: "post",
            url:
              window.config.api_v1 + "/research-framework-server/fum/key/page",
            data: {
              pageNum: _this.pageNum,
              pageSize: 20,
              param: {},
              qid: new Date(),
            },
            headers: {
              Token: _this.$route.query.token,
            },
          })
          .then(function (res) {
            let arr = res.data.data.data;

            // 加载状态结束
            _this.loading = false;

            if (arr.length >= 20) {
              _this.pageNum++;
              _this.list = _this.list.concat(arr);
            } else {
              _this.finished = true;
              _this.list = _this.list.concat(arr);
            }
          })
          .catch(function () {});
      },
      //返回股票涨幅对应的颜色
      judgeColor: function (n) {
        if (n == 0) {
          return "gray";
        } else if (n > 0) {
          return "red";
        } else if (n < 0) {
          return "green";
        }
      },

      toFixedNum: function (value, toFixed = 2, unit = "") {
        if (value && value !== "--") {
          return Number(value).toFixed(toFixed) + unit;
        } else if (value === 0) {
          return "0.00" + unit;
        } else {
          return "-";
        }
      },

      getCurrentDate() {
        const date = new Date();
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
      },

      //跳转详情页
      handleClickDetails(item) {
        let _this = this;
        let i = item.factorName + "(" + item.unit + ")";
        let indexName = encodeURIComponent(i);
        let url = `jhyjDetail?DZHSPECIAL=281&level3Code=${
          item.indusCode
        }&indexId=${item.factorId}&date=${_this.getCurrentDate()}&freq=${
          item.factor.updateFreq
        }&indexName=${indexName}`;
        this.toUrl(url);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .red {
    color: #ef3939 !important;
  }
  .green {
    color: #1eac4e !important;
  }
  .gray {
    color: #999;
  }
  .All {
    .th-ul {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #fafafa;
      padding: 0 0.2rem;
      li {
        padding: 0.08rem 0;
        color: #999999;
        font-size: 0.12rem;
        width: 20%;
        text-align: center;
        &:first-child {
          width: 1.13rem;
          text-align: left;
        }
        &:nth-child(2) {
          text-align: right;
        }
        &:last-child {
          width: 10%;
        }
      }
    }
    .td-ul {
      height: 6.2rem;
      overflow-y: auto;
      li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.14rem 0.16rem;
        &:nth-child(even) {
          background: #fafafc;
        }
        span {
          width: 20%;
          text-align: center;
          color: #1d2129;
          font-size: 0.12rem;
          &:first-child {
            width: 1.13rem;
            text-align: left;
          }
          &:nth-child(2) {
            text-align: right;
          }
          &:last-child {
            width: 10%;
          }
        }
      }
    }
  }

  .black_theme {
    .th-ul {
      background: #1e1f29;
      color: #6b7687;
    }
    .td-ul {
      li {
        &:nth-child(even) {
          background: #1b1d29;
        }
        span {
          color: #e4e9fe;
        }
      }
    }
  }
</style>
